import { Component } from "@kluntje/core";
import { LOADING, SUCCESS } from "Helper/cssClasses";
import { ViewportObserver } from "@kluntje/services";

// events which subscription to send_to_messenger can have.
// see https://developers.facebook.com/docs/messenger-platform/discovery/send-to-messenger-plugin the event section
const FBSendToMessengerEvents = {
  RENDERED: "rendered",
  CLICKED: "clicked",
  NOT_YOU: "not_you",
  OPT_IN: "opt_in",
};

/**
 * Custom Element to load FB SDK and use the Send to Messenger Plugin to allow the FRAnky chat bot send user info regarding their flight
 *
 * @see https://developers.facebook.com/docs/messenger-platform/discovery/send-to-messenger-plugin
 * @fires fra-e-facebook-send-to-messenger:opt-in
 */
class FRAFacebookSendToMessenger extends Component {
  viewportObserver = ViewportObserver.getInstance();

  constructor() {
    super({
      events: [
        {
          event: "kl-in-vp",
          target: "this",
          handler: "handleInViewport",
        },
      ],

      props: {
        // ID of your Facebook App. see {@link FRAFacebookSendToMessenger.loadFBSDK} for its usage to initialize FB SDK
        fbAppId: {
          type: "string",
          required: true,
        },
      },
    });
  }

  /**
   * @override
   */
  afterComponentRender() {
    this.viewportObserver.observe(this);
  }

  /**
   * loads and initializes the Facebook javascript SDK
   *
   * @param {string} appId - ID of the Facebook App from developer App Dashboard
   * @returns {Promise<void>}
   */
  loadFBSDK(appId: string) {
    return new Promise<void>((resolve, _reject) => {
      // @see https://developers.facebook.com/docs/javascript/quickstart/
      window.fbAsyncInit = () => {
        window.FB.init({
          appId,
          autoLogAppEvents: true,
          xfbml: true,
          version: "v12.0",
        });
        resolve();
      };

      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      document.body.appendChild(script);
    });
  }

  /**
   * lazy loads FB SDK and initialize it,
   * after it picks up the send to messenger markup,
   * show/hide UI element on various events
   *
   */
  async handleInViewport() {
    this.viewportObserver.unobserve(this);

    await this.loadFBSDK(this.fbAppId);

    // @ts-ignore - typing is missing the send to messenger typing
    window.FB.Event.subscribe("send_to_messenger", e => {
      // @ts-ignore - typing is missing the send to messenger typing
      switch (e.event) {
        case FBSendToMessengerEvents.OPT_IN:
          this.classList.add(SUCCESS);
          this.dispatchEvent(
            new CustomEvent("fra-e-facebook-send-to-messenger:opt-in", {
              bubbles: true,
            }),
          );
          break;

        case FBSendToMessengerEvents.RENDERED:
          this.classList.remove(LOADING);
          break;

        default:
          break;
      }
    });
  }
}

customElements.define("fra-e-facebook-send-to-messenger", FRAFacebookSendToMessenger);

export default FRAFacebookSendToMessenger;
